import React from 'react';
import { Row, Column } from '@upgrade/react-components';
import getColumnsCount from '../../../utils/calculate-grid';
import InfoContainer from '../InfoContainer';

const InfoTypes = ({
  infoTypes: { columns, fontColor, items },
  fontWeight,
  itemTitleColor,
  itemTitleSize,
  textAlign = 'start'
}) => {
  const grid = getColumnsCount(columns);
  return (
    <Row smHorizontalAlign="center">
      <Column xs={12} sm={grid.container}>
        <Row gutter="small" xsHorizontalAlign={textAlign}>
          {items.map(({ image, title: itemTitle, description, list, link, ctaTitle }) => (
            <Column key={itemTitle} xs={12} sm={grid.colSize}>
              <InfoContainer
                image={image}
                titleColor={itemTitleColor || fontColor}
                titleFontWeight={fontWeight}
                titleFontSize={itemTitleSize}
                title={itemTitle}
                description={description}
                list={list}
                link={link}
                ctaTitle={ctaTitle}
              />
            </Column>
          ))}
        </Row>
      </Column>
    </Row>
  );
};

export default InfoTypes;
